import React from "react";
import { IKImage } from "imagekitio-next";

const urlEndpoint = process.env.NEXT_PUBLIC_BASE_IMAGE_KIT_URL;
const CarouselImageWidth = 800;
const CarouselImageHeight = 800;

function CarouselImage({ imageName, alt, zoom }) {
  return (
    <IKImage
      key={imageName}
      src={`${urlEndpoint}/${imageName || "default_image.jpg"}?tr=w-800`}
      urlEndpoint={urlEndpoint}
      path={imageName || "default_image.jpg"}
      transformation={[{ crop: "maintain_ratio" }]}
      width={CarouselImageWidth}
      height={CarouselImageHeight}
      alt={alt}
      className="aspect-square object-contain transition-transform duration-300 ease-in-out"
      style={{
        transform: `scale(${zoom})`,
      }}
      lqip={{ active: true, quality: 20 }}
      loading="lazy"
    />
  );
}

export default CarouselImage;
